/* eslint-disable multiline-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {
  GMT_0,
  SHORT_DATE,
} from '_utils/constant'
import { Link } from 'react-router-dom'

const GroupMember = ({ userInfo, role = 'member', onClickPending }) => {
  const { orderCount } = userInfo

  const renderRoleBadge = () => {
    if (role === 'admin' && userInfo?.approval === 1) {
      return (
        <button
          type='button'
          className='btn-role-badge btn-role-badge--pending'
          onClick={onClickPending}
        >
          PENDING
        </button>
      )
    }
    const roleName = userInfo?.isAdmin ? 'ADMIN' : userInfo?.isHost ? 'HOST' : 'MEMBER'
    return (
      <span className={`role-badge role-badge--${roleName.toLowerCase()}`}>
        {roleName}
      </span>
    )
  }

  return (
    <div className='row member-table-card__row'>
      <div className='col-3 member-col member-col--date'>
        {moment.unix(userInfo?.createdAt).utcOffset(GMT_0).format(SHORT_DATE)}
      </div>
      <div className='col-3 member-col member-col--name'>
        {role === 'admin' ? (
          <Link
            to={`/group/detail-member?gid=${userInfo?.gid}&uid=${userInfo?.uid}`}
            className='member-name-link'
          >
            {userInfo?.name || userInfo?.uName}
          </Link>
        ) : (
          <span className='member-name-link member-name-text'>
            {userInfo?.uName || userInfo?.name}
          </span>
        )}
      </div>
      <div className='col-2 member-col member-col--events text-center'>
        <span className='member-events-count'>{userInfo.totalEvents ? userInfo.totalEvents : 0}</span>
        <i className='icon-mute member-events-icon'></i>
      </div>
      <div className='col-2 member-col member-col--purchase text-center'>
        <span className='member-purchase-count'>{orderCount || 0}</span>
        <span className='member-purchase-label'>BUY</span>
      </div>
      <div className='col-2 member-col member-col--permission text-center'>
        {renderRoleBadge()}
      </div>
    </div>
  )
}

GroupMember.propTypes = {
  events: PropTypes.array,
  onClickPending: PropTypes.func,
  role: PropTypes.string,
  userInfo: PropTypes.shape({
    approval: PropTypes.number,
    gid: PropTypes.string,
    isAdmin: PropTypes.number,
    isHost: PropTypes.number,
    name: PropTypes.string,
    uid: PropTypes.string,
  }),
}

export default GroupMember
